import { AppDispatch } from "../../store";
import { siteContextRequest } from "../../redux/siteContextRequest";
import config from "../../config";

interface IControlPlan {
  maxZoomLevel: number;
  tilesPath: string;
}

export const fetchControlPlan = (customerId: string, siteId: string) => async (
  dispatch: AppDispatch,
): Promise<IControlPlan> => {
  const response = await dispatch(
    siteContextRequest(customerId, siteId, {
      method: "GET",
      url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/control-plan`,
    }),
  );

  // TODO: add validation, e.g. using JSON schema

  return response.data.controlPlan;
};
